import React from "react";
import { Ptag } from "../../../components/fonts";
import { Error, PhoneInput, PhoneInputWrapper } from "./style";
import { useState } from "react";
import { useMemo } from "react";
import { LargeButton } from "../../../components";
import { getAbout, updatePassword } from "./util";
import { useHistory } from "react-router-dom";

function ResetPage() {
  const history = useHistory();

  const [newPassword, setNewPassword] = useState({
    base: "",
    confirmation: "",
  });

  const error = useMemo(() => {
    if (!newPassword.base || !newPassword.confirmation) return false;
    if (newPassword.base != newPassword.confirmation) return true;
  }, [newPassword]);

  const email = useMemo(() => {
    const about = getAbout();
    if (about && about.email) return about.email;
  });

  const resetPasswordHandler = async () => {
    await updatePassword(email, newPassword.base);
    history.push("/business/dashboard");
  };

  return (
    <div style={{ background: "white", padding: "4rem" }}>
      <div style={{ maxWidth: "1000px" }}>
        <Ptag
          fontSize="24px"
          fontWeight="700"
          style={{ paddingBottom: "36px" }}
        >
          Reset Password
        </Ptag>

        <div style={{ display: "flex", gap: "2rem", flexDirection: "column" }}>
          <div>
            <Ptag fontSize="18px" marginBottom="1rem">
              New Password
            </Ptag>
            <PhoneInputWrapper>
              <PhoneInput
                type="password"
                value={newPassword.base}
                onChange={(e) => {
                  e.persist();
                  setNewPassword((prev) => ({
                    ...prev,
                    base: e.target.value,
                  }));
                }}
                pattern="[A-Za-z]{3}"
                maxLength="10"
              />
            </PhoneInputWrapper>
          </div>
          <div>
            <Ptag fontSize="18px" marginBottom="1rem">
              Confirm Password
            </Ptag>
            <PhoneInputWrapper>
              <PhoneInput
                type="password"
                value={newPassword.confirmation}
                onChange={(e) => {
                  e.persist();
                  setNewPassword((prev) => ({
                    ...prev,
                    confirmation: e.target.value,
                  }));
                }}
                pattern="[A-Za-z]{3}"
                maxLength="10"
              />
              {error && <Error>Password is not matching</Error>}
            </PhoneInputWrapper>
          </div>
        </div>
        <LargeButton
          disabled={error || !newPassword.base || !newPassword.confirmation}
          label="Submit"
          onClick={resetPasswordHandler}
          style={{
            marginTop: "80px",
            opacity:
              error || !newPassword.base || !newPassword.confirmation
                ? "0.6"
                : "1",
          }}
        />
      </div>
    </div>
  );
}

export default ResetPage;
